import "./PrintingPresslist.css";
import { useState, useRef } from "react";
import Axios from "axios";
import swal from "sweetalert";

function CreatePrintingPress() {
  const [Pressname, setPressname] = useState("");
  const [Personname, setPersonname] = useState("");
  const [mobno, setmobno] = useState("");
  const [whatsappno, setwhatsappno] = useState("");
  const [email, setemail] = useState("");
  const [address, setaddress] = useState("");
  const [gst, setgst] = useState("");
  const [pancard, setpancard] = useState("");
  const [aadhar, setaadhar] = useState("");
  const [listO, setlistO] = useState([]);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValues, setEditedValues] = useState({});

  const firstInputRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!Pressname) {
      swal({
        title: "Error",
        text: "Please enter Printing Press Name.",
        icon: "error",
      });
      return;
    }
    const jsonData = {
      Pressname,
      Personname,
      mobno,
      whatsappno,
      email,
      address,
      aadhar,
      gst,
      pancard,
    };

    Axios.post("https://nodei.ssccglpinnacle.com/createPress", jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log("Data sent successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error sending data:", error);
      });
    swal({
      title: "Printing Press Created",
      text: "",
      icon: "success",
    });
    window.location.reload(false);
  };

  return (
    <>
      <div className="csd">
        <h3 style={{ textAlign: "center" }}> Create Printing Press </h3>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            maxWidth: "500px",
            margin: "0 auto",
            padding: "16px",
            border: "1px solid #ccc",
            borderRadius: "8px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>
              Printing Press Name:{" "}
              <span
                style={{
                  color: "red",
                  fontSize: "12px",
                  position: "relative",
                  top: "-2px",
                }}
              >
                &#9733;
              </span>
            </label>
            <input
              ref={firstInputRef}
              type="text"
              name="dname"
              value={Pressname}
              required
              onChange={(e) => setPressname(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Contact Person Name:</label>
            <input
              type="text"
              name="pname"
              value={Personname}
              onChange={(e) => setPersonname(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Mobile Number:</label>
            <input
              type="number"
              name="mobno"
              value={mobno}
              onChange={(e) => setmobno(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Whatsapp Number:</label>
            <input
              type="number"
              name="whatsappno"
              value={whatsappno}
              onChange={(e) => setwhatsappno(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Email:</label>
            <input
              type="text"
              name="email"
              value={email}
              onChange={(e) => setemail(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Address of Press:</label>
            <textarea
              name="shippingaddress"
              value={address}
              onChange={(e) => setaddress(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                resize: "vertical",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>Aadhar Number:</label>
            <input
              type="number"
              name="Aadhar"
              value={aadhar}
              onChange={(e) => setaadhar(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>GST Number:</label>
            <input
              type="text"
              name="gst"
              value={gst}
              onChange={(e) => setgst(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label>PAN Card Number:</label>
            <input
              type="text"
              name="pancard"
              value={pancard}
              onChange={(e) => setpancard(e.target.value)}
              style={{
                padding: "6px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            />
          </div>

          <button
            type="submit"
            onClick={handleSubmit}
            style={{
              padding: "8px 16px",
              backgroundColor: "#4CAF50",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
}

export default CreatePrintingPress;
